import { TOPNAV_HEIGHT_DESKTOP, TOPNAV_HEIGHT_MOBILE } from 'config'
import { styled, keyframes } from 'lib/theme'
import { Flex } from 'primitives/Flex'

const fadeIn = keyframes({
  '0%': { opacity: 0 },
  '70%': { opacity: 0 },
  '100%': { opacity: 1 },
})

export const FeedContainer = styled(Flex, {
  position: 'relative',
  width: '100%',
  flexDirection: 'column',
  // On load transition - attempts to hides scroll position restoration `scrollToIndex` jank
  animation: `${fadeIn} 250ms`,
  variants: {
    fixedAppHeight: {
      true: {
        height: `calc(var(--app-height) - ${TOPNAV_HEIGHT_MOBILE}px)`,
        '@lg': {
          height: `calc(var(--app-height) - ${TOPNAV_HEIGHT_DESKTOP}px)`,
        },
      },
    },
    scrollable: {
      true: {
        display: 'block',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      },
    },
  },
})
